import { serializeTitle } from '@/utils/index.js'

export default [
  {
    path: '/login',
    component: () => import(/* webpackChunkName: "security" */ '@/views/User.vue'),
    children: [{
      name: 'Login',
      path: '',
      component: () => import(/* webpackChunkName: "security" */ '@/components/user/security/Login.vue'),
      meta: {
        title: serializeTitle('Connexion'),
        guest: true,
      },
    }]
  }, {
    path: '/reset-password',
    component: () => import(/* webpackChunkName: "security" */ '@/views/User.vue'),
    children: [{
      path: 'check-mail',
      name: 'ResettingCheckEmail',
      component: () => import(/* webpackChunkName: "security" */ '@/components/user/resetting/CheckEmail.vue'),
      meta: {
        title: serializeTitle('Réinitialisation de votre mot de passe'),
        guest: true,
      },
    }, {
      path: 'email-sent',
      name: 'ResettingEmailSent',
      component: () => import(/* webpackChunkName: "security" */ '@/components/user/resetting/EmailSent.vue'),
      meta: {
        title: serializeTitle('Lien de réinitialisation envoyé'),
        guest: true,
      },
    }, {
      path: 'reset/:token',
      name: 'ResettingReset',
      component: () => import(/* webpackChunkName: "security" */ '@/components/user/resetting/Reset.vue'),
      meta: {
        title: serializeTitle('Modification du mot de passe'),
        guest: true,
      },
    }]
  }, {
    path: '/choose-customer',
    name: 'ChooseCustomer',
    component: () => import(/* webpackChunkName: "security" */ '@/views/ChooseCustomer.vue'),
    meta: {
      title: serializeTitle('Choix client'),
      requiresAuth: true,
    },
  }
]